module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "chevron-left.e3152a22.svg";